import React from 'react';
import './ToggleSwitch.css';

const ToggleSwitch = ({ checked, onChange }) => {
	return (
		<div className="checkbox-wrapper-6 ml-auto">
			<input
				type="checkbox"
				id="toggle"
				className="tgl tgl-light"
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
			/>
			<label htmlFor="toggle" className="tgl-btn"></label>
		</div>
	);
};

export default ToggleSwitch;
